import { Classified } from '../../rest/types/Classified'
import { AdsSortingFiltersVariant } from '../../components/AdsSortingFilters/styled'
import { ListDisplayType } from '../../types/classified'

export function ClassifiedEmitterFiltersTransformer({
  t,
  classifieds,
  numberClassifieds,
  setDisplayType,
  displayTypeParams,
}: {
  t: any
  classifieds: Array<Classified>
  numberClassifieds?: number
  setDisplayType: (string: ListDisplayType) => void
  displayTypeParams?: ListDisplayType
}) {
  return classifieds
    ? {
        displaySelect: {
          name: 'display',
          labelProps: { underlined: false },
          value: displayTypeParams,
          options: [
            {
              label: t('listingSearchAdsDisplayMapOptionLabel'),
              value: ListDisplayType.Map,
            },
            {
              label: t('listingSearchAdsDisplayListOptionLabel'),
              value: ListDisplayType.List,
            },
            {
              label: t('listingSearchAdsDisplayCardOptionLabel'),
              value: ListDisplayType.Card,
            },
          ],
          onChange: (e: any) => {
            setDisplayType(e.target.value)
          },
        },
        adsNumber: `${
          numberClassifieds
            ? String(numberClassifieds)
            : String(classifieds?.length)
        } ${
          (classifieds?.length && classifieds?.length > 1) ||
          (numberClassifieds && numberClassifieds > 1)
            ? t('ads_number_listing_plural_label')
            : t('ads_number_listing_singular_label')
        }`,
        variant: AdsSortingFiltersVariant.secondary,
        isOpen: false,
      }
    : undefined
}
